export default class MultipleInputs {
	public idArr: number[] = []
	readonly MAX: number = 10
	private uniqueId = 0

	constructor(len?: number, max?: number) {
		const length = len || 0
		while (this.idArr.length < length) {
			this.idArr.push(this.uniqueId++)
		}
		this.MAX = max || this.MAX
	}

	add({ index, callback }: { index?: number; callback?: Function } = {}) {
		if (this.idArr.length >= this.MAX) {
			return false
		} else {
			if (index || index === 0) {
				if (callback) {
					callback(this.uniqueId, this.MAX)
				}
				this.idArr.splice(index + 1, 0, this.uniqueId++)
			} else {
				if (callback) {
					callback(this.uniqueId, this.MAX)
				}
				this.idArr.push(this.uniqueId++)
			}
		}
		return this.idArr
	}

	remove(index: number) {
		if (this.idArr.length <= 0) {
			return false
		} else {
			this.idArr.splice(index, 1)
		}
		return this.idArr
	}

	reset() {
		this.idArr = []
		this.uniqueId = 0
	}
}
